// Custom cursor implementation
export default class CustomCursor {
  constructor() {
    this.initCursor();
    this.initHovers();
    this.excludeScrollToTop();
  }

  initCursor() {
    // Add class to html to hide default cursor
    document.documentElement.classList.add('has-custom-cursor');
    
    // Get cursor elements
    this.outerCursor = document.querySelector(".circle-cursor--outer");
    this.innerCursor = document.querySelector(".circle-cursor--inner");
    
    if (!this.outerCursor || !this.innerCursor) return;
    
    this.clientX = -100;
    this.clientY = -100;
    this.showCursor = false;

    // Update cursor position on mouse move
    document.addEventListener("mousemove", e => {
      // Check if the cursor is over the scroll-to-top button
      const scrollTopButton = document.getElementById('scroll-to-top');
      if (scrollTopButton) {
        const rect = scrollTopButton.getBoundingClientRect();
        if (e.clientX >= rect.left && e.clientX <= rect.right && 
            e.clientY >= rect.top && e.clientY <= rect.bottom) {
          // Don't update custom cursor when over scroll-to-top button
          this.hideCustomCursor();
          return;
        } else {
          this.showCustomCursor();
        }
      }
      
      this.clientX = e.clientX;
      this.clientY = e.clientY;
      
      if (!this.showCursor) {
        this.showCursor = true;
      }
    });

    // Animation loop for cursor movement
    const render = () => {
      if (this.innerCursor && this.outerCursor && this.showCursor) {
        // Update both cursors to follow the mouse position
        this.innerCursor.style.left = `${this.clientX}px`;
        this.innerCursor.style.top = `${this.clientY}px`;
        this.outerCursor.style.left = `${this.clientX}px`;
        this.outerCursor.style.top = `${this.clientY}px`;
      }
      
      requestAnimationFrame(render);
    };
    
    requestAnimationFrame(render);
  }
  
  hideCustomCursor() {
    if (this.innerCursor && this.outerCursor) {
      this.innerCursor.style.opacity = "0";
      this.outerCursor.style.opacity = "0";
    }
  }
  
  showCustomCursor() {
    if (this.innerCursor && this.outerCursor) {
      this.innerCursor.style.opacity = "1";
      this.outerCursor.style.opacity = "1";
    }
  }

  initHovers() {
    // Get all interactive elements, explicitly excluding the scroll-to-top button
    const interactiveElements = document.querySelectorAll('a:not(#scroll-to-top), button:not(#scroll-to-top), input[type="button"], input[type="submit"], .cursor-pointer:not(#scroll-to-top)');
    
    // Add hover effect to interactive elements
    interactiveElements.forEach(element => {
      element.addEventListener('mouseenter', () => {
        this.outerCursor.classList.add('is-hover');
      });
      
      element.addEventListener('mouseleave', () => {
        this.outerCursor.classList.remove('is-hover');
      });
    });
  }
  
  excludeScrollToTop() {
    // Make sure scroll-to-top is excluded from custom cursor effects
    const scrollBtn = document.getElementById('scroll-to-top');
    if (scrollBtn) {
      // Ensure the button has proper cursor
      scrollBtn.style.cursor = 'pointer';
      
      // Add event listeners to hide custom cursor when hovering over scroll-to-top
      scrollBtn.addEventListener('mouseenter', () => {
        this.hideCustomCursor();
      });
      
      scrollBtn.addEventListener('mouseleave', () => {
        this.showCustomCursor();
      });
    }
  }
}

// Initialize the custom cursor when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Check if the device is not a touch device before initializing
  if (!('ontouchstart' in window)) {
    new CustomCursor();
  }
});

// Also initialize on turbo:load for Bridgetown's Turbo support
document.addEventListener('turbo:load', () => {
  // Check if the device is not a touch device before initializing
  if (!('ontouchstart' in window)) {
    new CustomCursor();
  }
});

// Fallback for browsers that might not fire DOMContentLoaded properly
window.addEventListener('load', () => {
  // Check if the device is not a touch device before initializing
  if (!('ontouchstart' in window) && !window.customCursorInitialized) {
    window.customCursorInitialized = true;
    new CustomCursor();
  }
});
